import React from 'react';
import classNames from 'classnames';
import get from 'lodash.get';

import TeaseCard from 'components/TeaseCard';
import TeasePicture from 'components/TeasePicture';
import ContentTimestamp from 'components/ContentTimestamp';
import Link from 'components/Link';
import TeaseCategory from 'components/TeaseCategory';

import buildUrl from 'lib/buildUrl';
import AIMS_FLAVORS from '../../../../lib/aimsFlavors';

const onlyMobileToolkit = ['pl5', 'pl0-m', 'pt5'];

const block = 'featuredTease';

// TODO, detach this from TeaseCard (props)
class FeaturedTease extends TeaseCard {
  date() {
    const {
      showTimestamp,
      content,
    } = this.props;

    if (!showTimestamp) {
      return null;
    }

    const dateCreated = get(content, 'item.dateCreated');
    const datePublished = get(content, 'item.datePublished');

    const timeStamp = (
      <ContentTimestamp
        dateCreated={dateCreated}
        datePublished={datePublished}
        layout="split"
      />
    );

    if (timeStamp) {
      return (
        <span className={`${block}__date db`}>
          {timeStamp}
        </span>
      );
    }

    return null;
  }

  author() {
    const { showAuthor, content } = this.props;
    const bylineToolkitClasses = ['founders-mono', 'f2', 'lh-copy', 'ls-tight', 'white'];

    if (!showAuthor || !get(content, 'item.authors[0]')) {
      return null;
    }

    return (
      <p className={classNames('featured-tease__byline', bylineToolkitClasses, onlyMobileToolkit)}>
        { get(content, 'item.authors[0].person.name') }
        { this.date() }
      </p>
    );
  }

  dek() {
    const { showDek, content } = this.props;

    const dek = get(content, 'computedValues.dek');
    if (!showDek || !dek) {
      return null;
    }

    return (
      <p className={classNames('featured-tease__dek', this.props.styles.dek, onlyMobileToolkit)}>
        {dek}
      </p>
    );
  }

  featuredAuthor() {
    const { showFeaturedAuthor, content } = this.props;

    const firstAuthorIsFeatured = get(content, 'featuredAuthor.firstAuthorIsFeatured');
    const byline = get(content, 'bylines[0]');
    if (
      !showFeaturedAuthor
      || !firstAuthorIsFeatured
      || !byline
    ) {
      return null;
    }

    return (
      <span className={classNames('featured-tease__author', this.props.styles.featuredAuthor)}>
        {byline.name}
      </span>
    );
  }

  render() {
    const { content } = this.props;
    if (!content) return null;

    const { id, type, computedValues } = content;
    const { headline, unibrow } = computedValues;

    const url = buildUrl(content);

    return (
      <article className="featured-tease" data-contentid={id}>
        <h1 className={classNames('featured-tease__title', onlyMobileToolkit)}>
          <Link to={url}>
            {this.featuredAuthor()}
            {' '}
            {headline}
          </Link>
        </h1>

        { this.dek() }
        { this.author() }

        <div className="featured-tease__picture">
          <Link to={url}>
            <TeasePicture
              responsiveFlavors={{
                s: AIMS_FLAVORS.FOCAL_760x380,
                m: AIMS_FLAVORS.FOCAL_920x460,
                l: AIMS_FLAVORS.FOCAL_552x276,
                xl: AIMS_FLAVORS.FOCAL_696x348,
              }}
              type={type}
              computedValues={computedValues}
              placeholder
            />
          </Link>
          <TeaseCategory
            type={type}
            unibrow={unibrow}
            style="featured-tease__category" // eslint-disable-line react/style-prop-object
            iconUrl={url}
          />
        </div>
      </article>
    );
  }
}

export default FeaturedTease;
